module.exports = require("@seddi/three/addons/shaders/CopyShader.js");